/**
 * pv-bundle.js — "Insieme a questo" nella scheda prodotto.
 *
 * Somma il prezzo del formato selezionato e quello degli extra spuntati,
 * aggiorna il totale e la riga della soglia di spedizione gratuita, e aggiunge
 * tutto al carrello in una sola chiamata a /cart/add.js.
 *
 * Il segnale del formato selezionato e' l'evento `variant:update` di Horizon,
 * lo stesso usato dai blocchi Klarna, «prendine due» e «le tre promesse».
 * Dopo l'aggiunta risolve un CartLinesUpdateEvent (@shopify/events) con le
 * sezioni del carrello, come fa assets/pv-upsell.js, cosi' il drawer si
 * aggiorna senza ricaricare la pagina (Horizon non ascolta piu' `cart:update`).
 */
(function () {
  if (window.__pvBundleInit) return;
  window.__pvBundleInit = true;

  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = import('@shopify/events').catch(function () {
        return null;
      });
    }
    return eventsModule;
  }

  // Formato valuta del negozio (data-money-format), come i prezzi stampati da Liquid
  function pvMoney(cents, format) { var fixed = (cents / 100).toFixed(2).split('.'); var intDot = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); var intCom = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); var values = { amount: intCom + '.' + fixed[1], amount_no_decimals: intCom, amount_with_comma_separator: intDot + ',' + fixed[1], amount_no_decimals_with_comma_separator: intDot }; return String(format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) { return values[key] || values.amount_with_comma_separator; }); }

  var money = function (cents, format) {
    return pvMoney(cents, format);
  };

  function extras(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-pv-bundle-item] input[type="checkbox"]'));
  }

  function total(root) {
    var base = parseInt(root.dataset.basePrice, 10) || 0;
    return extras(root).reduce(function (sum, cb) {
      return cb.checked ? sum + (parseInt(cb.dataset.price, 10) || 0) : sum;
    }, base);
  }

  function paint(root) {
    var currency = root.dataset.moneyFormat;
    var sum = total(root);
    var threshold = parseInt(root.dataset.threshold, 10) || 0;

    var amount = root.querySelector('[data-pv-bundle-total]');
    if (amount) amount.textContent = money(sum, currency);

    var note = root.querySelector('[data-pv-bundle-note]');
    if (note && threshold > 0) {
      if (sum >= threshold) {
        note.textContent = root.dataset.noteReached || '';
      } else {
        note.textContent = (root.dataset.noteShort || '').replace('[mancano]', money(threshold - sum, currency));
      }
    }

    var count = extras(root).filter(function (cb) {
      return cb.checked;
    }).length;
    var btn = root.querySelector('[data-pv-bundle-add]');
    if (btn) {
      btn.dataset.label = count > 0 ? root.dataset.labelAll : root.dataset.labelOne;
      var text = btn.querySelector('[data-pv-bundle-label]');
      if (text) text.textContent = btn.dataset.label;
    }
  }

  function paintAll() {
    document.querySelectorAll('[data-pv-bundle]').forEach(paint);
  }

  document.addEventListener('variant:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (!r || r.id == null) return;
    document.querySelectorAll('[data-pv-bundle]').forEach(function (root) {
      root.dataset.variantId = r.id;
      if (typeof r.price === 'number') root.dataset.basePrice = r.price;
      paint(root);
    });
  });

  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('[data-pv-bundle]');
    if (root) paint(root);
  });

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pv-bundle-add]') : null;
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-pv-bundle]');
    if (!root) return;
    e.preventDefault();

    var label = btn.querySelector('[data-pv-bundle-label]');
    var restore = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = root.dataset.labelBusy || '…';

    try {
      var items = [{ id: Number(root.dataset.variantId), quantity: 1 }];
      extras(root).forEach(function (cb) {
        if (cb.checked) items.push({ id: Number(cb.dataset.variantId), quantity: 1 });
      });

      var sectionIds = Array.prototype.map
        .call(document.querySelectorAll('cart-items-component'), function (el) {
          return el.dataset.sectionId;
        })
        .filter(Boolean);

      var payload = { items: items };
      if (sectionIds.length) payload.sections = sectionIds.join(',');

      var events = await loadEvents();
      var LinesEvent = events && events.CartLinesUpdateEvent;
      var deferred = LinesEvent ? LinesEvent.createPromise() : null;

      if (LinesEvent) {
        document.dispatchEvent(
          new LinesEvent({
            action: 'add',
            context: 'product',
            lines: items.map(function (it) {
              return { merchandiseId: it.id, quantity: it.quantity };
            }),
            promise: deferred.promise
          })
        );
      }

      var addUrl = ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
      var res = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });
      var data = await res.json();

      var cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });

      if (data.status) {
        if (deferred) {
          deferred.resolve({
            cart: LinesEvent.createCartFromAjaxResponse(cart),
            detail: { didError: true, items: cart.items, source: 'pv-bundle', sourceId: 'pv-bundle', itemCount: items.length }
          });
        }
        btn.disabled = false;
        if (label) label.textContent = restore;
        return;
      }

      if (!sectionIds.length || !LinesEvent) {
        window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
        return;
      }

      deferred.resolve({
        cart: LinesEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'pv-bundle',
          sourceId: 'pv-bundle',
          itemCount: items.length,
          sections: data.sections,
          didError: false
        }
      });

      btn.disabled = false;
      if (label) label.textContent = restore;
    } catch (err) {
      console.error('pv-bundle', err);
      btn.disabled = false;
      if (label) label.textContent = restore;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})();
